<template>
  <div style="height:100%">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.4">
      <template #table1>
        <TableMain name="one table" ref="OrderForecastDispatchSearchTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :show_date_choose="true" @on_query="on_query" @tool_invoke="tool_invoke"
          @current_changed="current_changed" @only_methods="only_methods" :hb_table_class="'hb_table_ofds_class1'"
          :only_text="$t('common.only_dispatch_uncomplated')" :isBusy="isBusy_table1" :table_height_adjust="-8"
          :loading_width="50" tableref="105dfd84343c44f3b4d197e384188092">
          <template #query>
            <el-select v-model="dateChoose" placeholder="" size="small" style="width: 100px">
              <el-option :label="$t('common.delivery_date')" value="date1"></el-option>
              <el-option :label="$t('common.order_date')" value="date2"></el-option>
            </el-select>
            <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
              :picker-options="pickerOptions()">
            </el-date-picker>
            {{ $t("common.label_forecast_order_num") }}：<el-input size="small" style="width: 95px" clearable
              v-model="ForecastSalesId"></el-input>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <BaseContainer style="height:100%" class="one_table">
          <TableMain name="two table" :fields="fields2" :show_query_container="false"
            ref="OrderForecastDispatchSearchTable2" title="table_forecast_dispatch" :table_height_adjust="8"
            :isBusy="isBusy_table2" :loading_width="50" :hb_table_class="'hb_table_ofds_class2'" :show_email="true"
            @email_invoke="SendEmail" @state_change="dispatch_state_change" :show_toolbar_button="[0, 0, 1, 1, 1, 0, 0]"
            @on_change="on_change" tableref="49baf08b678a49f498d7de6af6d13403">
            <template #operation>
              <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
                @on_query="Table2_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
            </template>
          </TableMain>
        </BaseContainer>
      </template>
    </SplitContainer2>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as OrderForecastController from "../../controllers/sd/OrderForecastController"
import * as OrderForecastDispatchAddController from "../../controllers/sd/OrderForecastDispatchAddController"
import * as OrderForecastDispatchSearchController from "../../controllers/sd/OrderForecastDispatchSearchController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as notify_template from "../../shared/notify_template"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer2 from "../components/container/SplitContainer2"
import TableMain from "../components/table/TableMain"

export default {
  name: "OrderForecastDispatchSearch",
  components: {
    BaseContainer,
    TableMain,
    TestQueryPanel,
    SplitContainer2,
    QueryButton,
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_forecast_detail",
      },
      fields: OrderForecastDispatchSearchController.fields.default,
      fields2: OrderForecastDispatchSearchController.fields.dicpatch_fields,
      rules: OrderForecastDispatchSearchController.rules,
      isBusy_table1: false,
      isBusy_table2: false,
      ForecastSalesId: "",
      his_SOLine_data: [],
      his_dispatch_list: [],
      changed_list: [],
      all_role_users: [],
      invent_m: null,
      OrderInfo: null,
      all_role_list: [],
      date_range: "",
      dateChoose: "date1"
    }
  },
  async created() {
    let _fields = _.find(this.fields2, { key: "ModelId" })
    _.remove(_fields, (n) => {
      return n == "id"
    })
    _fields["_options"] = {
      provider: (v) => {
        let order_m =
          this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
        if (order_m) {
          let sf_models = _.filter(
            this.$store.state.biz_data.baseData.ForecastModel,
            { dataAreaId: order_m.dataAreaId }
          )
          return _.map(sf_models, (v) => {
            return {
              value: v.ModelId,
              label: v.ModelId + ": " + v.Txt,
            }
          })
        } else {
          return []
        }
      },
    }
    await this.getAllRoles()
    await this.getAllRoleUsers()
  },
  computed: {
    userCust() {
      return this.$store.state.biz_data.userInfo.user_custs
    },
  },
  watch: {
    userCust(newV, oldV) {
      if (newV && window.location.href.indexOf("?k=") > -1) {
        this.ForecastSalesId = window.location.href.split("?k=")[1]

        this.on_query(this.$refs.OrderForecastDispatchSearchTable1.SetData)
      }
    },
  },
  mounted() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
  },
  methods: {
    pickerOptions() {
      let this_ = this
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.filter(_dt, { is_sys: false, is_valid: true })
    },
    async getAllRoleUsers() {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_all_rolecode_username",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_dispatch_orderforecast_line",
      // ]);
      // if (!ckp) {
      //   set_data([]);
      //   return;
      // }
      set_data([])
      this.isBusy_table1 = true
      let _fromDate = "",
        _toDate = ""
      let _params = {
        // "is_deleted": { "=": 0 },
        // "ForecastSalesId": { "like": "%" + this.ForecastSalesId + "%" }
        s_ForecastSalesId: this.ForecastSalesId,
      }
      if (this.dateChoose == "date1") {
        if (!_.isNull(this.date_range) && this.ForecastSalesId == "") {
          let _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
          let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
          _toDate = this.$date.format(
            this.$date.addDays(new Date(_toDate), 1),
            "yyyy-MM-dd"
          )
          _params.FromDate = _fromDate
          _params.ToDate = _toDate
        }
      } else {
        if (!_.isNull(this.date_range) && this.ForecastSalesId == "") {
          let _fromOrderDate = this.$date.format(
            this.date_range[0],
            "yyyy-MM-dd"
          )
          let _toOrderDate = this.$date.format(
            this.date_range[1],
            "yyyy-MM-dd"
          )
          _toOrderDate = this.$date.format(
            this.$date.addDays(new Date(_toOrderDate), 1),
            "yyyy-MM-dd"
          )
          _params.FromOrderDate = _fromOrderDate
          _params.ToOrderDate = _toOrderDate
        }
      }


      let _result = await OrderForecastDispatchSearchController.methods.getData(
        _params
      )
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = []
        _.each(_result[0], (t) => {
          let _index = _.findIndex(
            this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccountId }
          )
          if (_index > -1) {
            _list.push(t)
          }
        })
        let dt = _.cloneDeep(
          _.orderBy(_list, ["order_forecast_id", "seq"], ["desc", "asc"])
        )

        this.his_SOLine_data = dt
        set_data(dt)
      }
      this.isBusy_table1 = false
    },
    only_methods(val) {
      console.log(val)
      if (val) {
        let _filter_data = _.filter(this.his_SOLine_data, function (t) {
          return t.valid_remain > 0
        })
        this.$refs.OrderForecastDispatchSearchTable1.SetData(_filter_data)
      } else {
        this.$refs.OrderForecastDispatchSearchTable1.SetData(
          this.his_SOLine_data
        )
      }
    },
    async getDispatchItems(data) {
      this.isBusy_table2 = true
      let _result =
        await OrderForecastDispatchSearchController.methods.getDispatchItems({
          OrderForecastLineId: data.id,
          // is_deleted: { "=": 0 },
        })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          commonController.methods.getUserNameFromRole(
            this.all_role_users,
            t,
            "fcGetSFDispatchApprover",
            "SFDApprover"
          )
        })
        this.$refs.OrderForecastDispatchSearchTable2.SetData(
          _.orderBy(_result[0], ["id"], ["desc"])
        )

        this.his_dispatch_list = _.cloneDeep(_result[0])
      }
      this.isBusy_table2 = false
    },

    async current_changed(old, current) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "s-sPlant_OrderForecast",
      //   "e-get_sei_invent",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      if (_.isNull(current)) {
        this.$refs.OrderForecastDispatchSearchTable2.SetData([])
        return
      }
      this.changed_list = []
      ///获取订单相关信息
      await this.getOrderInfo(current)
      ///获取派单明细
      await this.getDispatchItems(current)
      ///获取物料相关信息
      await this.getInventData()
      console.log(this.invent_m)
    },

    ///获取订单相关信息
    async getOrderInfo(current) {
      let _result = await OrderForecastController.methods.getData({
        id: current.order_forecast_id,
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.OrderInfo = _result[0][0]
      }
    },
    ///获取物料相关信息
    async getInventData() {
      let _soLine_m =
        this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()

      let _invent_info = await InventTableController.methods.getData({
        ItemId: _soLine_m.ItemId,
        dataAreaId: this.OrderInfo.dataAreaId,
      })
      if (!_.isNull(_invent_info) && _invent_info && _invent_info.length > 0) {
        this.invent_m = _invent_info[0][0]
      }
    },
    async dispatch_state_change(data, cb) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-CheckSFApproved",
      //   "d-sPlant_OrderForecast_Dispatch",
      //   "e-CheckIfCanModifySalesForcastDispatch",
      //   "e-update_sfl_validremain",
      //   "h-interface_invoke",
      //   "x-checkinterfaceresult",
      // ]);
      // if (!ckp) {
      //   cb(false);
      //   return;
      // }
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }

      if (
        data.state === "deleted" ||
        data.state === "unapproved" ||
        data.state == "cancel" ||
        data.state == "uncancel"
      ) {
        ///判断是否是自己创建的数据
        let is_my_data = true
        let _has_approve = true
        let valid_state_ok = true
        _.each(data.selected_items, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id &&
            data.state != "unapproved"
          ) {
            is_my_data = false
          } else if (data.state === "deleted" && t.fcCheckSFDApproved == true) {
            _has_approve = false
          }
          // else if (data.state == "cancel" && t.is_cancel) {
          //   valid_state_ok = false
          // } else if (data.state == "uncancel" && !t.is_cancel) {
          //   valid_state_ok = false
          // }
        })
        if (!is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"), "info")
        } else if (!_has_approve) {
          this.msgToasts(this.$t("notify.dispatched_not_deleted"), "info")
        }
        // else if (!valid_state_ok) {
        //   this.msgToasts("抱歉，不能对取消或未取消的派发执行取消或反取消操作！", "info");
        // }
        if (!is_my_data || !_has_approve || !valid_state_ok) {
          cb(false)
          return
        }
      }

      if (this.changed_list.length > 0 && data.state != "deleted") {
        this.msgToasts(this.$t("notify.save_before_approve"), "info")
        cb(false)
        return
      } else {
        await this.excuteStateChange(data, cb)
      }
    },
    async excuteStateChange(data, cb) {
      if (data.state === "deleted") {
        //已审核数据才调用AX接口
        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            let _line_current =
              this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
            ///检查订单是否审核
            let _is_order_approved =
              await OrderForecastDispatchSearchController.methods.checkOrderIsApproved(
                { salesForecastId: _line_current.order_forecast_id }
              )
            if (!_.isNull(_is_order_approved) && !_is_order_approved.state) {
              this.msgToasts(_is_order_approved.message, "info")
              cb(false)
              return
            }
            const loading = this.$loading({
              lock: true,
              text: this.$t("notify.waiting"),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })
            ///删除的集合
            let _list = _.cloneDeep(data.selected_items)

            let _update_soline_form = null
            if (_line_current) {
              _.each(_list, (m) => {
                m.qty = parseFloat(m.qty)
              })
              _update_soline_form = {
                id: _line_current.id,
              }
            }
            ///整理ax参数
            let ax_list = _.filter(_list, function (t) {
              return !_.isNull(t.AXId) && !_.isEmpty(t.AXId)
            })
            let ax_params = this.getAXParams(ax_list, "Delete", "No", 0)

            ///执行审核
            let _params = {
              delete_data: _list,
              update_soline_form: _update_soline_form,
              ax_params: ax_params,
            }

            let result =
              await OrderForecastDispatchSearchController.methods.deleteData(
                _params
              )
            if (!_.isNull(result)) {
              if (result.state == true) {
                ///成功
                if (result.data && result.data.length > 0) {
                  let _rdata = _.filter(result.data, {
                    Code: "data/e/update_sfl_validremain",
                  })
                  if (
                    _rdata.length > 0 &&
                    _rdata[0].Result &&
                    _rdata[0].Result.Data.length > 0
                  ) {
                    _line_current.valid_approve =
                      _rdata[0].Result.Data[0][0].valid_approve
                    _line_current.valid_remain =
                      _rdata[0].Result.Data[0][0].valid_remain
                  }
                }
                // _line_current.valid_approve = _update_soline_form.valid_approve;
                // _line_current.valid_remain = _update_soline_form.valid_remain;
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                ///删除邮件
                let notify_list = []
                _.each(data.selected_items, (t) => {
                  ///普通审批邮件
                  notify_list.push({
                    idx: t.id,
                    notify_type: "sfd_approve",
                  })
                })
                if (notify_list.length > 0) {
                  await commonController.methods.sendOrCancelNotify(
                    "cancel",
                    notify_list
                  )
                }
                cb(true)
              } else {
                let _venders = _.map(_list, "AccountNum")
                if (result.type == "ax") {
                  this.msgToasts(this.$t("notify.ax_error") + "：<hr/><div>" + this.$t("common.provider_num") + "：" +
                    _venders[0] + "，" + result.message + "</div>", "info", null, true)
                } else if (result.type == "plant") {
                  this.msgToasts(
                    this.$t("notify.action_unsuccessfully") + this.$t("notify.error_info") + "：<hr/><div>" + this.$t("common.provider_num") + "：" +
                    _venders[0] + "，" + result.message + "</div>", "info", null, true)
                }
                cb(false)
              }
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }

            loading.close()
          }
        })
      } else if (data.state === "approved" || data.state === "unapproved") {
        let _state = data.state == "approved" ? true : false
        let _msg = data.state == "approved" ? "审批" : "反审"
        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            ///检查
            let res_check = await this.checkData(data.selected_items, _state)
            if (!res_check) {
              cb(false)
              return
            }

            const loading = this.$loading({
              lock: true,
              text: this.$t("notify.waiting"),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })

            let res_msg = []
            let res_ax_msg = []
            for (var i in data.selected_items) {
              let _list = []
              _list.push(_.cloneDeep(data.selected_items[i]))
              let res_approve = await this.excuteApprove(_list, _state, data)
              if (res_approve != "") {
                if (res_approve.type == "ax") {
                  res_ax_msg.push(res_approve.msg)
                } else {
                  res_msg.push(res_approve.msg)
                }
              }
            }
            let _data_list = await OrderForecastDispatchSearchController.methods.getDispatchData({ id: { in: _.map(data.selected_items, "id") } })
            if (!_.isNull(_data_list) && _data_list && _data_list.length > 0) {
              _.each(data.selected_items, (t) => {
                let _m = _.find(_data_list[0], { id: t.id })
                if (_m) {
                  this.$refs.OrderForecastDispatchSearchTable2.UpdateItems({ id: t.id }, _m)
                }
              })
            }
            if (res_msg.length == 0 && res_ax_msg.length == 0) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              let _msg = ""
              if (res_msg.length > 0) {
                _msg += this.$t("notify.action_unsuccessfully") + this.$t("notify.error_info") + "：" + _.join(res_msg, " ")
              }
              if (res_ax_msg.length > 0) {
                _msg += this.$t("notify.ax_error") + "：" + _.join(res_ax_msg, " ")
              }
              this.msgToasts(_msg, "info", null, true)
              cb(false)
            }

            if (_state) {
              ///审批成功后发邮件
              let _emailList = _.filter(data.selected_items, {
                fcCheckSFDApproved: true,
              })
              let _ep = {
                notify_type: "sfd_approve_pass",
                subject: "sfd_approve_pass",
                idx: "id",
              }
              await this.sendEmailAfterApproved(_emailList, _ep)
            }
            await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'OrderForecastDispatchSearch', data, this)
            loading.close()
          }
          else {
            await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, 'OrderForecastDispatchSearch', data, this)
          }
        })
      } else if (data.state == "cancel" || data.state == "uncancel") {
        ///取消，反取消
        let _state = data.state == "cancel" ? true : false
        let _msg = data.state == "cancel" ? "取消" : "反取消"

        ///检查
        let is_check_ok = this.checkValidData(_.cloneDeep(data.selected_items))
        if (!is_check_ok) {
          cb(false)
          return
        }

        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            const loading = this.$loading({
              lock: true,
              text: this.$t("notify.saveing"),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })

            let res_msg = []
            let isValid = _state ? 1 : 0
            let select_list = _.cloneDeep(data.selected_items)
            for (var i in select_list) {
              let _list = []
              _list.push(select_list[i])
              let _update_soline_form_list = []
              _.each(_list, (t) => {
                if (
                  !_.includes(
                    _.map(_update_soline_form_list, "id"),
                    t.OrderForecast_Line_id
                  )
                ) {
                  _update_soline_form_list.push({
                    id: t.OrderForecast_Line_id,
                  })
                }
              })

              ///整理ax参数
              let ax_list = _.filter(_list, function (t) {
                return !_.isNull(t.AXId) && !_.isEmpty(t.AXId)
              })
              let ax_params = this.getAXParams(
                ax_list,
                "Update",
                "Yes",
                isValid
              )

              ///执行审核
              let update_params = []
              _.each(_list, (t) => {
                update_params.push({
                  id: t.id,
                  qty: t.qty,
                  OrderForecast_Line_id: t.OrderForecast_Line_id,
                  is_cancel: isValid,
                })
              })

              let _params = {
                update_data: update_params,
                update_soline_form_list: _update_soline_form_list,
                ax_params: ax_params,
              }

              let result = await OrderForecastDispatchSearchController.methods.cancelData(_params, this)
              if (!_.isNull(result)) {
                if (result.state == true) {
                  ///成功
                  _.each(_params.update_data, (t) => {
                    let m = _.find(data.selected_items, { id: t.id })
                    if (m) {
                      m.is_cancel = _state
                    }
                  })
                  if (result.data && result.data.length > 0) {
                    let _rdata = _.filter(result.data, {
                      Code: "data/e/update_sfl_validremain",
                    })
                    if (
                      _rdata.length > 0 &&
                      _rdata[0].Result &&
                      _rdata[0].Result.Data.length > 0
                    ) {
                      let _line_current =
                        this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
                      _line_current.valid_remain =
                        _rdata[0].Result.Data[0][0].valid_remain
                    }
                  }

                  this.changed_list = []
                } else {
                  res_msg.push("<hr/><div>" + result.message + "</div>")
                }
              }
            }

            if (res_msg.length == 0) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              this.msgToasts(_.join(res_msg, " "), "info", null, true)
              cb(false)
            }

            loading.close()
          }
        })
      }
    },
    async checkData(_list, _state) {
      let res_check = true
      if (_list && _list.length == 0) {
        this.msgToasts(this.$t("notify.must_selected_approved"), "info")
        res_check = false
      }
      ///检查是否已经审批或反审
      if (res_check && this.checkIsApproved(_list, "fcCheckSFDApproved", _state)) {
        this.msgToasts(this.$t("notify.has_approved_or_unapproved"))
        res_check = false
      }
      ///检查是否有该权限
      let _check_list = await this.checkApproveStatus()
      if (res_check && _check_list.length > 0 && _state) {
        this.msgToasts(this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）", "error")
        res_check = false
      }

      ///检查订单是否审核
      let _valid_m =
        this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
      let _is_order_approved =
        await OrderForecastDispatchSearchController.methods.checkOrderIsApproved(
          { salesForecastId: _valid_m.order_forecast_id }
        )
      if (res_check && !_.isNull(_is_order_approved) && !_is_order_approved.state) {
        this.msgToasts(_is_order_approved.message, "info")
        res_check = false
      }

      ///检查派发供应商是否包含物料
      let vi_check_list = []
      _.each(_list, (t) => {
        if (t._error && !_.includes(vi_check_list, t.AccountNum)) {
          vi_check_list.push(t.AccountNum)
        }
      })
      if (res_check && res_check && vi_check_list.length > 0) {
        this.msgToasts(this.$t("common.provider") + "：" + _.join(vi_check_list, "，") + this.$t("common.not_exist") + this.$t("common.invent"), "info")
        res_check = false
      }

      return res_check
    },
    async excuteApprove(_list, _state, data) {
      let _update_status_list = []
      let _roles = []
      let userPR =
        this.$store.state.biz_data.userInfo.user_roles_privileges.roles
      if (userPR) {
        _roles = _.map(userPR, "code")
      }
      for (var i in _list) {
        _list[i].is_approved = _state
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesForcastDispatch",
          ApproveType: "",
          ItemId: _list[i].id,
        })
        _.each(_as_result[0], (at) => {
          if (at) {
            if (_state) {
              if (
                _.includes(_roles, at.Approver) ||
                this.$global.global_data.local_username == at.Approver
              ) {
                at.is_approved = true
                at.username = this.$global.global_data.local_username
                at.order_dispatch_id = _list[i].id
                at.userId = this.$store.state.biz_data.userInfo.user_id
                _update_status_list.push(at)
              }
            } else {
              // if (
              //   _.includes(_roles, at.Approver) || this.$global.global_data.local_username == at.Approver || _list[i].create_by ==
              //   this.$store.state.biz_data.userInfo.user_id
              // ) {
              //   if (at.ApproveLevel != 1 && at.Approver == "") {
              //   } else {
              //     at.is_approved = false;
              //     at.username = this.$global.global_data.local_username;
              //     at.order_dispatch_id = _list[i].id;
              //     at.userId = this.$store.state.biz_data.userInfo.user_id
              //     _update_status_list.push(at);
              //   }
              // }
              at.is_approved = false
              at.username = this.$global.global_data.local_username
              at.order_dispatch_id = _list[i].id
              at.userId = this.$store.state.biz_data.userInfo.user_id
              _update_status_list.push(at)
            }
          }
        })
      }

      ///修改剩余数量和待审批数量
      let _update_valid_m = null
      let _valid_m =
        this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
      if (_valid_m) {
        _update_valid_m = { id: _valid_m.id }
      }
      // console.log(_update_valid_m);
      ///先调用ax接口
      ///再执行审核接口

      ///判定是否是公司(公司才调用ax)
      let ax_list = []
      _.each(_list, (t) => {
        let _company = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          VenderAccountNum: t.AccountNum,
        })
        if (_company) {
          t.dataArea = _company.DataArea
          ax_list.push(t)
        }
      })
      let _active = _state ? "Yes" : "No"
      ///整理ax参数
      let ax_params = this.getAXParams(ax_list, "", _active, 0)
      ///执行审核
      let _params = {
        approve_data: _update_status_list,
        update_valid_data: _update_valid_m,
        ax_params: ax_params,
        state: _state,
      }
      console.log(_params)
      let result = await OrderForecastDispatchSearchController.methods.approveData(_params)
      if (!_.isNull(result)) {
        // _valid_m.valid_approve = _current_valid < 0 ? 0 : _current_valid;
        if (result.state) {
          if (_state) {
            ///修改ax返回数据
            let _rdata = _.filter(result.data, {
              Code: "data/h/interface_invoke",
            })
            for (var i in _rdata) {
              let rt = _rdata[i].Result.Data[0][0].data[0]
              if (rt) {
                console.log(rt.AXId)
                ax_list[i].AXId = rt.AXId
                this.$refs.OrderForecastDispatchSearchTable2.UpdateItems(
                  { id: ax_list[i].id },
                  ax_list[i]
                )

                let _list_m = _.find(_list, { id: ax_list[i].id })
                if (_list_m) {
                  _list_m.AXId = rt.AXId
                }
              }
            }
          }
          _.each(_list, (a) => {
            let t = _.find(data.selected_items, { id: a.id })
            t.fcCheckSFDApproved = _state
            let _ap_list = _.find(_update_status_list, {
              order_dispatch_id: a.id,
            })
            t.fcGetSFDispatchApprover = ""
            if (_ap_list && _update_status_list && !t.fcCheckSFDApproved) {
              t.fcGetSFDispatchApprover = _ap_list.Approver
            }
          })

          ///修改明细信息到界面
          if (result.data && result.data.length > 0) {
            let _rdata = _.filter(result.data, {
              Code: "data/e/update_sfl_validremain",
            })
            if (
              _rdata.length > 0 &&
              _rdata[0].Result &&
              _rdata[0].Result.Data.length > 0
            ) {
              _valid_m.valid_approve =
                _rdata[0].Result.Data[0][0].valid_approve
            }
          }

          return ""
        } else {
          let _venders = _.map(_list, "AccountNum")
          if (result.type == "ax") {
            return {
              type: "ax",
              msg:
                "<hr/><div>" + this.$t("common.provider_num") + "：" +
                _venders[0] +
                "，" +
                result.message +
                "</div>",
            }
          } else {
            return {
              type: "plant",
              msg:
                "<hr/><div>" + this.$t("common.provider_num") + "：" +
                _venders[0] +
                "，" +
                result.message +
                "</div>",
            }
          }
        }
      } else {
        return ""
      }
    },
    checkValidData(_list) {
      let is_check_ok = true
      ///检查是否是已审批数据
      let is_approved_data = true
      _.each(_list, (t) => {
        if (!t.fcCheckSFDApproved) {
          is_approved_data = false
        }
      })
      if (!is_approved_data) {
        this.msgToasts(this.$t("notify.is_not_all_approved"), "info")
        is_check_ok = false
      }
      return is_check_ok
    },
    ///审批后发邮件
    async sendEmailAfterApproved(data, _p) {
      let _groupby_user = _.groupBy(data, "create_by_username")
      ///发邮件给创建人
      await this.exSendEmailAfterApproved(_groupby_user, _p)
      ///根据派发人发送邮件
      let list = []
      for (var i in data) {
        let _m = _.cloneDeep(data[i])
        let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: _m.AccountNum,
        })
        if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
          //邮件通知人
          let _dt = _.split(vend.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p)
      }
    },
    async exSendEmailAfterApproved(_list, _p) {
      let notify_list = []
      for (var d in _list) {
        let lang_code = notify_template.methods.getUserLangCode(this, d)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _email_params = {
          notify_type: _p.notify_type,
          subject: email_template[_p.subject],
          create_by_username: d,
          list: _list[d],
          orderline: this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem(),
          idx: _p.idx,
        }
        let _ep = notify_template.methods.getApprovedEmailTemplate(_email_params, this)
        notify_list.push(_ep)
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify("add", notify_list)
      }
    },
    ///检查是否已经审批或者反审
    checkIsApproved(items, code, state) {
      let _index = _.findIndex(items, (t) => {
        if (t[code] == state) {
          return t
        }
      })
      return _index > -1
    },
    ///调用ax接口
    getAXParams(_list, _Status, _ApproveStatus, _isVlid) {
      let _this = this

      let _valid_m =
        this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
      let _DW_InventUnitId = "个"
      if (this.invent_m && !_.isNull(this.invent_m)) {
        _DW_InventUnitId = this.invent_m.DW_InventUnitId
      }
      let _ax_params = []
      for (var i in _list) {
        let t = _list[i]
        if (_Status == "") {
          if (_.isNull(t.AXId) || t.AXId == "") {
            if (_ApproveStatus == "No") {
              continue
            }
          }
        }
        let _temp_status = _Status
        if (_Status == "") {
          if (!_.isNull(t.AXId) && t.AXId != "") {
            _temp_status = "Update"
          } else {
            _temp_status = "Create"
          }
        }
        ///整理jsonData
        let _jsonData = []
        _jsonData.push({
          ItemId: _valid_m.ItemId,
          RetailVariantId: t.RetailVariantId,
          StartDate: _this.formatDate(t.delivery_date),
          EndDate: "",
          Active: _ApproveStatus,
          IsCancel: _isVlid,
          CustAccountId: _this.OrderInfo.CustAccountId,
          CurrencyCode: "CNY", //_valid_m.Currency,
          orderId: _valid_m.ForecastSalesId, ///订单编号
          createdBy: _valid_m.create_by_username,
          SalesQty: t.qty,
          SalesUnitId:
            _.isEmpty(_DW_InventUnitId) == true ? "个" : _DW_InventUnitId,
          ModelId: t.ModelId, //_.isNull(_valid_m.ModelId) ? "" : _valid_m.ModelId,
          Status: _temp_status,
          AXId: t.AXId,
          SEI_CP_ReplenishmentCommit: t.SEI_CP_ReplenishmentCommit,
          WeekName: t.WeekName,
          CMForecastDispatchId: t.id
        })
        let _company = _.find(
          _this.$store.state.biz_data.baseData.CompanyInfo,
          { VenderAccountNum: t.AccountNum }
        )

        if (_company) {
          _ax_params.push({
            company: _company.DataArea,
            dic_id: t.id,
            jsonData: _jsonData,
          })
        }
      }
      return _ax_params
    },

    //数据检验
    async validData() {
      // ////======派单数量与剩余派单数量检查
      // let data = _.cloneDeep(
      //   _.filter(this.$refs.OrderForecastDispatchSearchTable2.my_data, (t) => {
      //     return t.is_deleted == false && t.is_approved == false;
      //   })
      // );
      // _.each(data, (t) => {
      //   t.qty = parseFloat(t.qty);
      // });
      // let _is_more_valid = false;
      // let _line_current = this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem();
      // if (_line_current) {
      //   let sum_dispathch = _.sumBy(data, "qty");
      //   if (
      //     sum_dispathch >
      //     _line_current.valid_remain + _line_current.valid_approve
      //   ) {
      //     _is_more_valid = true;
      //   }
      // }
      // if (_is_more_valid == true) {
      //   this.msgToasts(this.$t("notify.pcs_not_more_valid_dispatched_pcs"), "error");
      //   return false;
      // }

      return true
    },
    async on_change(data) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_vend_production_capacity",
      //   "e-check_isExiste_vend_item",
      //   "e-get_vend_invent_sum",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      let _m = _.cloneDeep(data.item)
      let _index = _.findIndex(this.changed_list, { id: _m.id })
      if (_index < 0) {
        this.changed_list.push(_m)
      } else {
        _.remove(this.changed_list, { id: _m.id })
        this.changed_list.push(_m)
      }
      if (data.field.key == "delivery_date") {
        this.setDisDataStateAndInfo("OrderForecastDispatchSearchTable2", [
          "qty",
          "delivery_date",
        ])
      }
    },
    ///保存修改
    async Table2_SaveData(cb) {
      //  let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-CheckSFApproved",
      //   "u-sPlant_OrderForecast_Dispatch",
      //   "e-CheckIfCanModifySalesForcastDispatch",
      //   "e-update_sfl_validremain",
      //   "e-sp_updateApproveStatus",
      //   "h-interface_invoke",
      //   "x-checkinterfaceresult",
      // ]);
      // if (!ckp) {
      //   return;
      // }

      ///判断是否是自己创建的数据
      let is_my_data = true
      let _data = this.changed_list
      _.each(_data, (t) => {
        if (
          t.create_by &&
          t.create_by != this.$store.state.biz_data.userInfo.user_id
        ) {
          is_my_data = false
        }
      })
      if (!is_my_data) {
        this.msgToasts(this.$t("notify.not_created_by_yourself"))
        cb(true)
        return
      }

      //检查数量
      let _qty_check_index = _.findIndex(
        this.$refs.OrderForecastDispatchSearchTable2.my_data,
        function (t) {
          return t.qty == 0 || t.qty == "" || _.isNull(t.qty)
        }
      )
      if (_qty_check_index > -1) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        cb(true)
        return
      }
      ///保存只针对未审核
      if (this.changed_list.length > 0) {
        let _this = this
        let _line_current =
          this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
        ///检查订单是否审核
        let _is_order_approved =
          await OrderForecastDispatchSearchController.methods.checkOrderIsApproved(
            { salesForecastId: _line_current.order_forecast_id }
          )
        if (!_.isNull(_is_order_approved) && !_is_order_approved.state) {
          this.msgToasts(_is_order_approved.message, "info")
          cb(false)
          return
        }
        let _index = _.findIndex(this.changed_list, (t) => {
          return t.fcCheckSFDApproved == true
        })
        if (_index > -1) {
          this.msgToasts(this.$t("notify.approved_can_not_be_edited"), "info")
          _.each(this.changed_list, (t) => {
            let _m = _.find(_this.his_dispatch_list, { id: t.id })
            t.qty = _m.qty
            t.price = _m.price
            t.delivery_date = _m.delivery_date
            t.Capacity = _m.Capacity
            t._current = false
            this.$refs.OrderForecastDispatchSearchTable2.UpdateItems(
              { id: t.id },
              t
            )
          })
          cb(false)
          return
        }
        //数据检测
        let _is_check_ok = await this.validData()
        if (!_is_check_ok) {
          cb(false)
          return
        }

        let _list = []
        let data = _.cloneDeep(this.changed_list)
        _.each(data, (t) => {
          let _m = _.cloneDeep(OrderForecastDispatchAddController.dataForm)
          for (var i in _m) {
            _m[i] = t[i]
          }
          if (t.delivery_date && _.isDate(t.delivery_date)) {
            _m.delivery_date = _this.$date.format(
              t.delivery_date,
              "yyyy-MM-dd"
            )
          }
          _m.qty = parseFloat(_m.qty)
          _list.push(_m)
        })

        let _update_soline_form_list = []

        if (_line_current) {
          let _alist = _.cloneDeep(
            _.filter(
              this.$refs.OrderForecastDispatchSearchTable2.my_data,
              (t) => {
                return t.is_deleted == false && t.is_approved == false
              }
            )
          )
          _.each(_alist, (m) => {
            m.qty = parseFloat(m.qty)
          })
          let sum_dispathch = _.sumBy(_alist, "qty")
          _update_soline_form_list.push({
            id: _line_current.id,
            valid_approve: sum_dispathch,
            valid_remain:
              _line_current.valid_remain -
              (sum_dispathch - _line_current.valid_approve),
          })
        }
        console.log(_update_soline_form_list)

        const loading = this.$loading({
          lock: true,
          text: this.$t("notify.saveing"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })

        ///整理ax参数
        let ax_list = _.filter(_list, function (t) {
          return !_.isNull(t.AXId) && !_.isEmpty(t.AXId)
        })
        let ax_params = this.getAXParams(ax_list, "Update", "No", 0)

        ///执行审核
        let _params = {
          update_data: _list,
          update_soline_form_list: _update_soline_form_list,
          ax_params: ax_params,
        }

        let result =
          await OrderForecastDispatchSearchController.methods.updateData(
            _params
          )
        if (!_.isNull(result)) {
          if (result.state == true) {
            ///成功
            if (result.data && result.data.length > 0) {
              let _rdata = _.filter(result.data, {
                Code: "data/e/update_sfl_validremain",
              })
              if (
                _rdata.length > 0 &&
                _rdata[0].Result &&
                _rdata[0].Result.Data.length > 0
              ) {
                _line_current.valid_approve =
                  _rdata[0].Result.Data[0][0].valid_approve
                _line_current.valid_remain =
                  _rdata[0].Result.Data[0][0].valid_remain
              }
            }

            this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(true)
            _.each(this.changed_list, (t) => {
              t.fcCheckSFDApproved = false
              t.is_email_send = false
              this.$refs.OrderForecastDispatchSearchTable2.UpdateItems(
                { id: t.id },
                t
              )
            })
            this.changed_list = []
          } else {
            let _venders = _.map(_list, "AccountNum")
            if (result.type == "ax") {
              this.msgToasts(
                this.$t("notify.ax_error") + "：<hr/><div>" + this.$t("common.provider_num") + "：" +
                _venders[0] +
                "，" +
                result.message +
                "</div>",
                "info",
                null,
                true
              )
            } else if (result.type == "plant") {
              this.msgToasts(this.$t("notify.action_unsuccessfully") + this.$t("notify.error_info") + "：<hr/><div>" + this.$t("common.provider_num") + "：" +
                _venders[0] + "，" + result.message + "</div>", "info", null, true)
            }
            cb(false)
          }
        } else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }

        loading.close()
      } else {
        cb(false)
      }
    },

    //#endregion

    ///审批邮件模板
    orderEmailTemplate(_selectedlist) {
      let _this = this
      let _params = {}
      let notify_list = []
      let order_line_m = this.$refs.OrderForecastDispatchSearchTable1.GetCurrentItem()
      let company_name = ""
      let _company_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
        DataArea: order_line_m.dataAreaId,
      })
      if (_company_m) {
        company_name = _company_m.CompanyName
      }
      _params.main = {
        type_name: "预测订单派发审批",
        url:
          window.location.protocol +
          "//" +
          window.location.host +
          "/sd/OrderForecastDispatch?k=" +
          order_line_m.ForecastSalesId,
        url_name:
          window.location.host +
          "/sd/OrderForecastDispatch?k=" +
          order_line_m.ForecastSalesId,
        forcast_code: order_line_m.ForecastSalesId,
        customer_name: order_line_m.CustAccountName,
        model_id: order_line_m.ModelId,
        invent_id: order_line_m.ItemId,
        invent_name: order_line_m.NameAlias,
        variant_name: order_line_m.VariantName,
        sales_qty: order_line_m.SalesQty,
        forcast_rate: order_line_m.SEI_ForecastAccuracy,
        forcast_type: order_line_m.SEI_ForecastSalesType,
        delivery_date: this.formatDate(
          order_line_m.StartDate
        ),
        sales_company: company_name,
        forcast_description: _.isNull(order_line_m.description)
          ? ""
          : order_line_m.description,
        username: this.$global.global_data.local_username,
        create_at: _this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
      }
      _.each(_selectedlist, async (t) => {
        let lang_code = notify_template.methods.getUserLangCode(this, t.SFDApprover)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _notify_p = {
          category: "sfd_approve",
          idx: t.id,
          itemId: t.id,
          notify_type: "sfd_approve",
          subject: email_template["sfd_approved_be_care"],
          content: "",
        }
        _params.email_user = t.SFDApprover
        _params.items = []
        _params.items.push({
          vend_num: t.AccountNum,
          vend_name: t.SEI_Name,
          qty: t.qty,
          capacity: t.Capacity,
          total_score: t.TotalScore,
          delivery_date: this.formatDate(
            t.delivery_date
          ),
          dispatch_description: "",
        })

        let _index = _.findIndex(notify_list, { idx: t.id })
        if (_index < 0) {
          _notify_p.content = notify_template.methods.getForcastDispatchTemplate(_params, this)
          notify_list.push(_notify_p)
        }
      })
      return notify_list
    },
    ///send email
    SendEmail(data) {
      ///判断是否是自己创建的数据
      let is_my_data = true
      let _data =
        this.$refs.OrderForecastDispatchSearchTable2.GetSelectedItems()
      _.each(_data, (t) => {
        if (
          t.create_by &&
          t.create_by != this.$store.state.biz_data.userInfo.user_id
        ) {
          is_my_data = false
        }
      })
      if (!is_my_data) {
        this.msgToasts(this.$t("notify.not_created_by_yourself"))
        return
      }

      let _this = this
      let _list = _.orderBy(
        this.$refs.OrderForecastDispatchSearchTable2.GetSelectedItems(),
        ["id"],
        ["desc"]
      )
      if (_list.length > 0) {
        if (data.code == "add") {
          this.msgModal(this.$t("notify.is_send_email")).then(async (v) => {
            if (v) {
              let _so_ids = []
              _.each(_list, async (t) => {
                _so_ids.push(t.id)
              })

              let notify_list = []

              //====审批
              let order_email_list = _.filter(_list, {
                fcCheckSFDApproved: false,
              })
              let _order_email_temp_list = this.orderEmailTemplate(order_email_list)
              if (_order_email_temp_list.length > 0) {
                notify_list = _.union(notify_list, _order_email_temp_list)
              }

              // console.log(notify_list)
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.email_seccess"), "success")
                  await commonController.methods.updateEmailSendState("sfd", _list)
                  _.each(_list, (t) => {
                    t.is_email_send = true
                  })
                }
              } else if (_list.length > 0 && notify_list.length == 0) {
                _this.msgToasts(this.$t("notify.approved_can_not_send_email"), "info")
              }
            }
          })
        } else {
          this.msgModal(this.$t("notify.is_repeal_email")).then(async (v) => {
            if (v) {
              let notify_list = []
              _.each(_list, (t) => {
                ///普通审批邮件
                notify_list.push({
                  idx: t.id,
                  notify_type: "sfd_approve",
                })
              })
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.approved_email_cancel_success"), "success")
                }
              }
            }
          })
        }
      } else {
        this.msgToasts(this.$t("notify.not_data"), "info")
      }
    },

    ///获取或设置派单相关信息
    async setDisDataStateAndInfo(table_ref, woFields) {
      let _p = {
        get_pc: [],
      }
      ///获取产能
      _.each(this.$refs[table_ref].my_data, (t) => {
        _p.get_pc.push({
          AccountNum: t.AccountNum,
          delivery_date: t.delivery_date,
          _seq: t._id,
        })
      })

      let _table3_list = this.$refs[table_ref].my_data
      console.log(_table3_list)
      let _result =
        await OrderForecastDispatchAddController.methods.getDisDataStateAndInfo(
          _p
        )
      if (!_.isNull(_result) && _result) {
        ///设置产能
        let _filter_pc = _.filter(_result, {
          Code: "data/e/get_vend_production_capacity",
        })
        _.each(_filter_pc, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            if (t.Result.Data && !_.isNull(t.Result.Data)) {
              for (var i in t.Result.Data) {
                let _m = _.cloneDeep(
                  _.find(_table3_list, { _id: t.Params[i]._seq })
                )
                _m.Capacity = 0
                if (!_.isNull(t.Result.Data[i][0].ProductionCapacity)) {
                  _m.Capacity = t.Result.Data[i][0].ProductionCapacity
                }
                this.$refs[table_ref].UpdateItemsWOField(
                  { _id: t.Params[i]._seq },
                  _m,
                  woFields
                )
              }
            }
          }
        })
      }
    },

    ///检查是否包含该审批权限
    async checkApproveStatus() {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _selected_list =
        this.$refs.OrderForecastDispatchSearchTable2.GetSelectedItems()
      for (var i in _selected_list) {
        let t = _selected_list[i]
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesForcastDispatch",
          ApproveType: "",
          ItemId: t.id,
        })
        console.log(_roles, _as_result)
        let _is_ok = true
        for (var j in _as_result[0]) {
          let at = _as_result[0][j]
          if (at) {
            if (
              _.includes(_roles, at.Approver) ||
              this.$global.global_data.local_username == at.Approver
            ) {
              _is_ok = false
            }
          }
        }
        if (_is_ok && !_.includes(_check_list, t.id)) {
          _check_list.push(t.id)
        }
      }
      return _check_list
    },


  },
}
</script>
<style>
.hb_table_ofds_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 130rem;
}

.hb_table_ofds_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 140rem;
}
</style>
